import React, { useState } from "react";
import PropTypes from "prop-types";

import { CodeIcon } from "assets/images";
import openUrlInNewTab from "util/openUrlInNewTab";
import globalStyles from "globalStyles";
import { K_COLORS_DARK_BLUE, K_COLORS_LIGHT_BLUE } from "constants.js";
import useWindowSize from "hooks/useWindowSize";
import { K_MOBILE_SIZE } from "constants.js";

const ProjectCard = (props) => {
  const { title, content, url } = props;
  const { width } = useWindowSize();

  const [isVerticalBorderExpanding, setIsVerticalBorderExpanding] = useState(
    false,
  );
  const [
    isHorizontalBorderExpanding,
    setIsHorizontalBorderExpanding,
  ] = useState(false);

  const styles = {
    ...pcStyles,
    ...(width < K_MOBILE_SIZE ? mobileStyles : {}),
  };

  const setIsHovered = (isHovered) => {
    if (isHovered) {
      setIsHorizontalBorderExpanding(true);
      setTimeout(() => {
        setIsHorizontalBorderExpanding(true);
        setIsVerticalBorderExpanding(true);
      }, 250);
    } else {
      setIsVerticalBorderExpanding(false);
      setTimeout(() => {
        setIsVerticalBorderExpanding(false);
        setIsHorizontalBorderExpanding(false);
      }, 250);
    }
  };

  const verticalBorderStyle = {
    transition: "height 0.25s",
    width: "1px",
    height: isVerticalBorderExpanding ? "100%" : "0",
    backgroundColor: K_COLORS_LIGHT_BLUE,
    position: "absolute",
  };
  const horizontalBorderStyle = {
    transition: "width 0.25s",
    height: "1px",
    width: isHorizontalBorderExpanding ? "100%" : "0",
    backgroundColor: K_COLORS_LIGHT_BLUE,
    position: "absolute",
  };

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        ...styles.cardContainer,
        ...{ position: "relative", display: "flex", flexDirection: "row" },
      }}
    >
      <div style={{ ...verticalBorderStyle, ...{ bottom: "0", left: "0" } }} />
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ ...horizontalBorderStyle, ...{ top: "0", left: "0" } }} />
        <div style={styles.card}>
          <div style={styles.imageContainer}>
            <div
              style={styles.imageHolder}
              onClick={() => openUrlInNewTab(url)}
            >
              <CodeIcon />
            </div>
          </div>
          <div style={styles.title}>{title}</div>
          <div style={styles.content}>{content}</div>
        </div>
        <div
          style={{ ...horizontalBorderStyle, ...{ bottom: "0", right: "0" } }}
        />
      </div>
      <div style={{ ...verticalBorderStyle, ...{ top: "0", right: "0" } }} />
    </div>
  );
};

const pcStyles = {
  cardContainer: {
    margin: "1.5vh",
  },
  card: {
    padding: "1.8rem",
    textAlign: "left",
    transition: "0.75s",
    minWidth: "250px",
    width: "calc(100vw / 4)",
    minHeight: "calc(100vw / 4)",
    overflow: "hidden",
    backgroundColor: K_COLORS_DARK_BLUE,
  },
  title: {
    ...globalStyles.textTitleSize,
    ...globalStyles.textLightBlueColor,
    marginBottom: "0.75rem",
  },
  imageContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  imageHolder: {
    cursor: "pointer",
    backgroundColor: K_COLORS_LIGHT_BLUE,
    borderRadius: "50%",
    height: "22px",
    width: "22px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    ...globalStyles.textLightGreyColor,
    fontSize: "1vw",
  },
};

const mobileStyles = {
  cardContainer: {
    marginLeft: "0.1rem",
    marginRight: "0.1rem",
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  card: {
    padding: "1.75rem",
    textAlign: "left",
    transition: "0.75s",
    width: "280px",
    minHeight: "280px",
    overflow: "hidden",
    backgroundColor: K_COLORS_DARK_BLUE,
  },
  title: {
    ...globalStyles.textLightBlueColor,
    fontSize: "1rem",
    marginBottom: "0.5rem",
  },
  content: {
    ...globalStyles.textLightGreyColor,
    fontSize: "0.8rem",
  },
};

ProjectCard.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default ProjectCard;
